import * as React from "react";

import {cs}      from "../../chain-services";
import {Invoke1} from "../../invoke";
import {Static2} from "../../static-2";

export const SideEffectRender = ({isActive, render}) => cs(
    ["counter", (_, next) => Static2({next})],
    ({counter}) => isActive() && (
        React.createElement(Invoke1, {
            key: counter.set((counter.get() ?? 0)+1),
            action: render,
        })
    ),
);
